import { type ReactNode } from 'react';
import * as React from 'react';

interface CaptionProps {
  children: ReactNode;
}

export const Caption: React.ComponentType<CaptionProps> = React.memo(
  ({ children }) => {
    return (
      <figcaption
        className="gatsby-resp-image-figcaption"
        style={{ marginTop: 0 }}>
        {children}
      </figcaption>
    );
  }
);
